<section class="testi-area7 bg-smoke overflow-hidden space-top py-5" id="testi-sec"
    data-bg-src="assets/img/bg/map2.png">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xl-6">
                <div class="title-area mb-40">
                    <span class="sub-title text-anime-style-2">Testimonial</span>
                    <h2 class="sec-title text-anime-style-3">What Client Say About us</h2>
                </div>
                <div class="swiper th-slider testiSlide5" id="testiSlide7"
                    data-slider-options='{"effect":"slide","loop":false,"thumbs":{"swiper":".testi-grid2-thumb"}}'>
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="testi-grid2">
                                <div class="box-content">
                                    <p class="box-text">“The programmer is a genuine hard-working developer. He works to
                                        high standards and always communicated every day with updates. I will work with
                                        him again as I like his attitude.”</p>
                                    <h6 class="box-title">Dave | UK</h6>
                                    <div class="box-review">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="testi-grid2">
                                <div class="box-content">
                                    <p class="box-text">“To be honest, Mach provided me with a very high quality of
                                        work. Higher than what I expected. He always keeps me updated every hour, really
                                        enjoy working with him I recommend him for HTML 5 work!”</p>
                                    <h6 class="box-title">PSD to HTML (Sam)</h6>
                                    <div class="box-review">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="testi-grid2">
                                <div class="box-content">
                                    <p class="box-text">“What can I say? I am used to buying templates from Themeforest.
                                        But this time I wanted to try out a custom design. To do so I hired XIPE TECH to
                                        slice my design and add functionality to my HTML site. I was amazed by the
                                        result.”</p>
                                    <h6 class="box-title">The WhiteLabel</h6>
                                    <div class="box-review">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="testi-grid2">
                                <div class="box-content">
                                    <p class="box-text">“Xipe Tech Team is very professional and has point-blank
                                        developers. I definitely will hire them again. The Xipe Tech team was very
                                        communicative about the issues we had and had the knowledge to point out them.
                                        Great Team!”</p>
                                    <h6 class="box-title">Zend Client | UK</h6>
                                    <div class="box-review">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="testi-grid2">
                                <div class="box-content">
                                    <p class="box-text">“The Xipe Tech team was very good at communication and managed
                                        the project professionally. Look forward to working with them again. Xipe Tech
                                        completed the assigned… ”</p>
                                    <h6 class="box-title">Squarespace | Australia</h6>
                                    <div class="box-review">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="testi-grid2">
                                <div class="box-content">
                                    <p class="box-text">“The Xipe Tech team was very quick, was very patient with my
                                        short brief, understood what I need quickly. I will hire them again. ”</p>
                                    <h6 class="box-title">CI | Malaysia</h6>
                                    <div class="box-review">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper th-slider testi-grid2-thumb style2"
                    data-slider-options='{"effect":"slide","slidesPerView":"6","spaceBetween":7,"loop":false}'>
                    <div class="icon-box">
                        <button data-slider-prev="#testiSlide7" class="slider-arrow default"><img
                                src="assets/img/icon/right-arrow2.svg" alt=""></button>
                        <button data-slider-next="#testiSlide7" class="slider-arrow default"><img
                                src="assets/img/icon/left-arrow2.svg" alt=""></button>
                    </div>
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="box-img">
                                <img src="assets/img/testimonial/default-user.png" alt="Dave | UK" />
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="box-img">
                                <img src="assets/img/testimonial/default-user.png" alt="PSD to HTML (Sam)" />
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="box-img">
                                <img src="assets/img/testimonial/default-user.png" alt="The WhiteLabel" />
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="box-img">
                                <img src="assets/img/testimonial/default-user.png" alt="Zend Client | UK" />
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="box-img">
                                <img src="assets/img/testimonial/default-user.png" alt="Squarespace | Australia" />
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="box-img">
                                <img src="assets/img/testimonial/default-user.png" alt="CI | Malaysia" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-6">
                <div class="testi-image-wrapp2">
                    <div class="testi-img">
                        <img src="assets/img/testimonial/testi-img1.jpg" alt="">
                    </div>
                    <div class="testi-img2">
                        <img src="assets/img/testimonial/testi-img2.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>